import {useSelector, useDispatch} from "react-redux";
import {addItem, resetItems, setTitle} from "../redux/slices/menuSlice";
import React from "react";
import useDocumentTitle from "../hooks/useDocumentTitle";
import useAuth from "../hooks/useAuth";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faChevronDown } from '@fortawesome/free-solid-svg-icons'
import ListCourses from "../components/catalog/ListCourses";
import {Outlet, Navigate, useLocation, useNavigate, Link, useParams} from "react-router-dom";
import CatalogListPage from "./catalog/CatalogListPage";
import EntityApi from "../api/EntityApi";
import Modal from "../components/main/Modal";
import CatalogCategoryFormModal from "../modals/CatalogCategoryFormModal";
import {Button, Modal as ModalAntd} from "antd";
import {menuSelector} from "../redux/slices/menuSlice";


const CatalogPage = () => {

    const title = "Каталог курсов";
    useDocumentTitle(title);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const menu = useSelector(menuSelector);
    const { id } = useParams();
    const { roles } = useAuth();
    const [titleHeader, setTitleHeader] = React.useState(title);
    const [isPopperOpen, setIsPopperOpen] = React.useState(false);
    const [isOpenCategory, setIsOpenCategory] = React.useState(false);
    const [isLoadingCategories, setIsLoadingCategories] = React.useState(false);
    const [categoryId, setCategoryId] = React.useState(0);

    const [isOpenMobileCats, setIsOpenMobileCats] = React.useState(false);

    const popperRef = React.useRef(null);

    const nav = (link) => {
        setIsOpenMobileCats(false)
        navigate(link);
    }

    React.useEffect(() => {
        if (!isLoadingCategories) {
            dispatch(resetItems());
            dispatch(setTitle(title));

            EntityApi.getBy('private/category', {
                filter: {parent: 0}
            }).then((data) => {
                if (data.status === 'success') {
                    dispatch(addItem({title: 'Все курсы', link: "/cabinet/catalog", items: []}));
                    data.content.items.forEach((item) => {

                        let subitems = [];
                        item.subitems.forEach((subitem) => {
                            subitems.push({
                                title: subitem.title,
                                count: subitem.count,
                                link: "/cabinet/catalog/category/" + subitem.id
                            });
                        });

                        dispatch(addItem({title: item.title, count: item.count, link: "/cabinet/catalog/category/" + item.id, items: subitems}));
                    })
                    setIsLoadingCategories(true);
                }
            })
        }
    }, [isLoadingCategories])

    React.useEffect(() => {
        const handleClickOutside = (event) => {
            if (!event.composedPath().includes(popperRef.current)) {
                setIsPopperOpen(false);
            }
        }
        document.body.addEventListener('click', handleClickOutside);
        return () => {
            document.body.removeEventListener('click', handleClickOutside);
        }

    }, [])

    React.useEffect(() => {
        if (id !== undefined && parseInt(id) > 0) {
            setCategoryId(parseInt(id));
        } else {
            setCategoryId(0);
        }
    }, [id])
    const handleOpenNewCategory = () => {
        setIsPopperOpen(false);
        setIsOpenCategory(true);
    }

    const MobileCatsStyle = { position: 'fixed', top: '120px', zIndex: 100, left: '0px'}

    return (
     <>
         <div className="flex items-center justify-between py-5 lg:py-6">
            <div className="flex items-center space-x-1">
                <h2 className="line-clamp-1 text-xl font-medium text-slate-700 dark:text-navy-50 lg:text-2xl">
                    {titleHeader}
                </h2>
                {
                    roles.includes('ROLE_ADMIN') &&
                <div className="inline-flex">
                    <button ref={popperRef} onClick={(evt) => setIsPopperOpen(true)} className="popper-ref btn h-8 w-8 rounded-full p-0 hover:bg-slate-300/20 focus:bg-slate-300/20 active:bg-slate-300/25 dark:hover:bg-navy-300/20 dark:focus:bg-navy-300/20 dark:active:bg-navy-300/25">
                        <FontAwesomeIcon icon={faChevronDown} />
                    </button>
                    <div className={`popper-root${isPopperOpen ? ' show' : ''}`} style={{'position': 'absolute'}}>
                        <div className="popper-box rounded-md border border-slate-150 bg-white py-1.5 font-inter dark:border-navy-500 dark:bg-navy-700">
                            <ul>
                                <li>
                                    <Link to="/cabinet/catalog/form/course/0" onClick={() => setIsPopperOpen(false)} className="flex h-8 items-center space-x-3 px-3 pr-8 font-medium tracking-wide outline-none transition-all hover:bg-slate-100 hover:text-slate-800 focus:bg-slate-100 focus:text-slate-800 dark:hover:bg-navy-600 dark:hover:text-navy-100 dark:focus:bg-navy-600 dark:focus:text-navy-100">
                                        <FontAwesomeIcon icon={faPlus}/>
                                        <span> Добавить курс</span></Link>
                                </li>
                                <li>
                                    <a href="#" onClick={handleOpenNewCategory} className="flex h-8 items-center space-x-3 px-3 pr-8 font-medium tracking-wide outline-none transition-all hover:bg-slate-100 hover:text-slate-800 focus:bg-slate-100 focus:text-slate-800 dark:hover:bg-navy-600 dark:hover:text-navy-100 dark:focus:bg-navy-600 dark:focus:text-navy-100">
                                        <FontAwesomeIcon icon={faPlus}/>
                                        <span> Добавить раздел</span></a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                }

            </div>
        </div>
         <div className={'desktop-hidden'}>
             <Button className={'mb-4 desktop-hidden w-full'} onClick={() => setIsOpenMobileCats(!isOpenMobileCats)}>Категории</Button>
             <ModalAntd
                 style={{top: '0px'}}
                 title="Категории курсов"
                 open={isOpenMobileCats}
                 footer={''}
                 onCancel={() => setIsOpenMobileCats(false)}>
                 <div className={"card"}>
                     <div className={"p-4 sm:px-5"}>
                         <ul className={"space-y-1.5 font-inter font-medium"}>
                             {
                                 menu.items && menu.items.map((item, index) =>
                                     <li key={index}>
                                         <button onClick={() => {
                                             nav(item.link)
                                         }}
                                                 className="nav-link flex relative pr-8 text-left justify-between items-center w-full py-2 text-base tracking-wide outline-none transition-colors duration-300 ease-in-out text-slate-600 hover:text-primary dark:text-navy-200 dark:hover:text-navy-50">
                                             {item.title} {item.count > 0 && <span
                                             style={{
                                                 position: 'absolute',
                                                 right: '0',
                                                 top: '0.5rem'
                                             }}>({item.count})</span>}
                                         </button>
                                         {
                                             item.items &&
                                             <ul className="ac-panel">
                                                 {
                                                     item.items.map((subitem, subindex) => <li key={subindex}
                                                                                               style={{position: 'relative'}}>
                                                         <button onClick={() => nav(subitem.link)}
                                                                 className="w-full nav-link relative flex text-left items-center justify-between p-2 text-xs+ tracking-wide outline-none transition-[color,padding-left] duration-300 ease-in-out hover:pl-4">
                                                             <div
                                                                 className="flex items-center space-x-2 hover:text-primary">
                                                                 <div
                                                                     className="h-1.5 w-1.5 rounded-full border border-current opacity-40"></div>
                                                                 <span
                                                                     className={"flex w-full items-center justify-between"}
                                                                     style={{marginRight: '1rem'}}>
                                                                {subitem.title}
                                                                     {subitem.count > 0 && <span style={{
                                                                         position: 'absolute',
                                                                         right: '0',
                                                                         top: '0.5rem'
                                                                     }}>({subitem.count})</span>}
                                                            </span>
                                                             </div>
                                                         </button>
                                                     </li>)
                                                 }
                                             </ul>

                                         }
                                     </li>
                                 )
                             }
                         </ul>
                     </div>
                 </div>
             </ModalAntd>
         </div>

         <Outlet context={{categoryId, setIsLoadingCategories}}/>
         {
             roles.includes('ROLE_ADMIN') && <CatalogCategoryFormModal parentId={categoryId} isOpen={isOpenCategory}
                                                                       onSuccess={() => setIsLoadingCategories(false)}
                                                                       onClose={() => setIsOpenCategory(false)}/>
         }
     </>
    )

}

export default CatalogPage;
